import { client } from 'lib/evi-api-gateway';
const url = `${process.env.REACT_APP_API_URL_RESOURCE}/api`;
export async function checkToken() {
  return client.post({
    url: `${process.env.REACT_APP_API_URL_USER}/token/check_token`,
    form: {
      type: 'ZOOM',
      cache: 'Y'
    }
  });
}

// 得到事件列表
export async function getEventList(params: any) {
  return client.post({
    url: `${url}/get_list`,
    form: {
      limit: 9999,
      ...params
    }
  });
}

// 新增
export async function addEvent(form: any) {
  return client.post({
    url: `${url}/add`,
    form
  });
}

// 更新
export async function updateEvent(form: any) {
  return client.post({
    url: `${url}/update`,
    form
  });
}

// 刪除
export async function deleteEvent(id: any, is_update_parent: any) {
  return client.post({
    url: `${url}/delete`,
    form: {
      id,
      is_update_parent
    }
  });
}

// 獲取詳情
export async function get(id: any) {
  return client.post({
    url: `${url}/get`,
    form: {
      id
    }
  });
}

// 获取教职工列表
export async function staffList(params: any) {
  return client.post({
    url: `${url}/school/get_staff_list`,
    form: { ...params }
  });
}

// 获取班级列表
export async function classList(params: any) {
  return client.post({
    url: `${url}/school/get_class_list`,
    form: { ...params }
  });
}

// 获取学生列表
export async function studentList(params: any) {
  return client.post({
    url: `${url}/school/get_student_list`,
    form: { ...params }
  });
}

function gradeChange(region: any, grade: any) {
  if (region === 'my') {
    switch (grade) {
      case 'PN':
        return 'N1';
      case 'K1':
        return 'N2';
      case 'K2':
        return 'K1';
      case 'K3':
        return 'K2';
      default:
        return grade;
    }
  }
  return grade;
}

// 获取班级树
export async function getClassTree(region = 'hk') {
  return classList(null)
    .then((ret) => ret.rows)
    .catch((err) => [])
    .then((gList) => {
      let _ret = gList.reduce(
        (
          _list: any,
          { grade_id, year_name, grade_name, class_name, grade_type, class_id }: any
        ) => {
          const gradeType = gradeChange(region, grade_type);

          if (!_list[grade_type]) {
            _list[grade_type] = {
              label: `${gradeType}`,
              value: `${grade_type}`,
              // key: `${grade_type}`,
              children: []
            };
          }
          if (!_list[grade_type].children[grade_id]) {
            _list[grade_type].children[grade_id] = {
              label: `${year_name} ${grade_name}`,
              value: `${grade_type}-${grade_id}`,
              // key: `${grade_type}-${grade_id}`,
              children: []
            };
          }
          _list[grade_type].children[grade_id].children.push({
            label: `${class_name}`,
            value: `${grade_type}-${grade_id}-${class_id}`
            // key: `${grade_type}-${grade_id}-${class_id}`
          });
          return _list;
        },
        {}
      );
      (Object.keys(_ret) || []).map((_gType) => {
        _ret[_gType].children = Object.values(_ret[_gType].children);
        return true;
      });
      return { classTree: Object.values(_ret), classList: gList };
    });
}
